import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/lima1900.png";
import Imagen2 from "../../../images/modulo13/limaactual.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad3Actividad1.mp3";

const Actividad2 = () => {
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[0];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[1].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[1].path}`,
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[9].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[9].path}`,
  };

  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>
          Observa cada una de las imágenes y piensa: ¿qué ves en cada una?, ¿qué
          cambios se observan entre ellas?
        </li>
        <li>
          Luego, conversa con un compañero, compañera o familiar sobre lo que
          observaste. Tengan en cuenta las diferencias en el espacio, las
          construcciones y las actividades de la gente.
        </li>
      </ul>
      <h4 className="text-center mt-4">Año 1900</h4>
      <img src={Imagen1} className="img-fluid" alt="Peruanos" />
      <h4 className="text-center mt-5">Año 2000</h4>
      <img src={Imagen2} className="img-fluid" alt="Peruanos" />

      <div className="row mt-5">
        <div className="col-lg-10 col-12 mb-1">
          <ul className="">
            <li>
              Para cada una de las imágenes anteriores, escoge un detalle que
              muestre la escasez de recursos o servicios en las ciudades.
            </li>
            <li>Dibuja cada uno de los detalles que escogiste en una hoja.</li>
            <li>
              Luego, explícale a tu compañero, compañera o familiar por qué
              escogiste esos detalles.
            </li>
          </ul>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que en esta unidad realizarán actividades que buscan
            informar y reflexionar sobre el crecimiento de las ciudades en el
            territorio. A partir de ello, se espera que los alumnos se
            involucren participando en acciones que lleven a resolver los
            problemas y afrontar los retos del impacto del crecimiento de las
            ciudades. Señale que las primeras actividades buscan, a partir de la
            observación de imágenes, dar información sobre algunos cambios y
            problemas que han tenido las ciudades a partir de su crecimiento.
          </li>
          <li>
            Lea la primera indicación: Observa cada una de las imágenes y
            piensa: ¿qué ves en cada una?, ¿qué cambios se observan entre ellas?
            Aclare que en la primera imagen vemos una ciudad de principios del
            siglo XX y, en la segunda imagen, una ciudad más actual. Pídales que
            primero observen los detalles de las imágenes por separado y luego
            se fijen en los cambios entre una y otra imagen. Déles un tiempo
            para que realicen el trabajo individualmente. Lea la segunda
            indicación: Luego, conversa con un compañero o compañera sobre lo
            que observaste. Tengan en cuenta las diferencias en el espacio, las
            construcciones y las actividades de la gente. Ahora retome algunas
            de las respuestas. Ayude con las siguientes preguntas:
            <ul>
              <li>
                <i>
                  “Vamos a empezar por el espacio, ¿qué podemos decir acerca de
                  los espacios que se presentan en las imágenes? ¿Son espacios
                  atiborrados o despejados? (Posible respuesta: En la primera
                  imagen, el espacio está más despejado que en la segunda
                  imagen. No tiene tantas construcciones ni aglomeración de
                  gente).
                </i>
              </li>
              <li>
                <i>
                  ¿Y qué podemos decir acerca de las construcciones? (Posible
                  respuesta: En la primera imagen hay menos edificaciones. Se
                  ven los rieles del tranvía y una acequia. En la segunda imagen
                  hay pistas, edificios. Se ve que la ciudad sigue creciendo).
                </i>
              </li>
              <li>
                <i>
                  Y con respecto a la gente, ¿qué actividades vemos? (Posible
                  respuesta: En la primera imagen, hay gente vendiendo por la
                  calle y gente botando desechos y basura a la acequia. En la
                  segunda también hay gente caminando, otras personas manejan
                  sus autos y van en combi. Mucha gente espera la combi, parece
                  que no hay suficientes).
                </i>
              </li>
            </ul>
          </li>

          <li>
            Cierre la actividad señalando que las imágenes muestran el
            crecimiento y la modernización de las ciudades.
          </li>
          <li>
            Lea la primera indicación: Para cada una de las imágenes anteriores,
            escoge un detalle que muestre la escasez de servicios en las
            ciudades. Explique que, en las imágenes de la Actividad 1, se puede
            notar la ausencia de algunos servicios. Pida que ubiquen esta
            ausencia de servicios en cada una de las imágenes (no hay servicio
            de desagüe, por ejemplo, y el transporte público es escaso). Lea la
            siguiente indicación: Dibuja cada uno de los detalles que escogiste
            en los siguientes recuadros. Déles un tiempo para dibujar. Revise
            qué detalles están dibujando. Lea la siguiente indicación: Luego,
            explícale a tu compañero, compañera o familiar por qué escogiste
            esos detalles. Pregunte qué han dibujado y por qué. Por ejemplo:
            <ul>
              <li>
                <i>
                  “¿Qué dibujaron a partir de la primera imagen? (Pueden haber
                  dibujado la acequia porque representa la falta de servicio de
                  alcantarillado. También es posible que dibujen, por ejemplo, a
                  las personas botando la basura y el agua fuera de sus casas,
                  ante la ausencia de servicios de recojo de basura y desagües).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué dibujaron a partir de la segunda imagen? (Pueden haber
                  dibujado las combis llenas de personas como ejemplo de un
                  servicio de transporte público que no se da abasto).”
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
